/** @format */

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
//importing Assets
import M from "../../Assets/logos/M.svg";
import Drawer from "@mui/material/Drawer";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import Icons from "../../Assets/Icons";
import { sideMenu } from "../../constant/common";
// import "./index.scss";
import TextField from "@mui/material/TextField";
const RightMenu = ({ isMenuOpen, toggleMenu }) => {
  const [windowSize, setWindowSize] = useState(getWindowSize());
  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }
  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);
  const renderLink = (linkInfo) => {
    let active = window.location.pathname.includes(linkInfo.link);

    return (
      <Link to={linkInfo.link}>
        <div
          className={`right-menu__item ${
            active && "right-menu__item--active"
          }`}>
          {active ? linkInfo.activeIcon : linkInfo.icon}
          {isMenuOpen && <h3>{linkInfo.title}</h3>}
        </div>
      </Link>
    );
  };
  return (
    <div className={`menu ${!isMenuOpen && "menu--closed"}`} id='right-menu'>
      {windowSize.innerWidth > 950 ? (
        <>
          {" "}
          <div className='menu__toggle-icon'>
            {isMenuOpen ? (
              <IoIosArrowForward onClick={toggleMenu} />
            ) : (
              <IoIosArrowBack onClick={toggleMenu} />
            )}
          </div>
          <Link to='/'>
            {isMenuOpen ? (
              <div className={`menu__logo-box`}>
                <img src={M} alt='Logo' />
              </div>
            ) : (
              <Icons name='closedMenuLogo' />
            )}
          </Link>
          <div className={`right-menu`} id='right-menu'>
            {sideMenu.map((item) => renderLink(item))}
          </div>
        </>
      ) : (
        <div className='mobile-menu'>
          <Drawer anchor={"right"} open={isMenuOpen} onClose={toggleMenu}>
            <div className='mobile-menu__cont'>
              <div className={`menu__logo-box`}>
                <img src={M} alt='Logo' />
              </div>

              <br />
              <div className={`right-menu`} id='right-menu'>
                {sideMenu.map((item) => renderLink(item))}
              </div>
            </div>
          </Drawer>
        </div>
      )}
    </div>
  );
};
export default RightMenu;
